import './App.css';
import ChatBotFrame from './components/modal/ChatBotFrame';
import RoutesPaths from './components/pages/RoutesFile/RoutesPaths';

function App() {
  return (
    <div className="App">
      <RoutesPaths />
      <ChatBotFrame />
    </div>
  );
}

export default App;
